// @flow
import * as React from "react"
import { compose, type HOC } from "recompose"
import withQuery from "hoc/withQuery"
import withScrollEnd from "hoc/withScrollEnd"
import Loader from "components/Loader"
import { listProductOfferingsQuery } from "data/product/graphql/queries";
import { FullWidthContainer } from "componentsStyled/Layout/Containers"
import ProductList from "components/ProductList"
import type { Location, ProductGroup } from "data/app/types"

const NearbyProducts = ({ data, loading, loadingMore, ...rest }) => (
  <FullWidthContainer>
    <ProductList productOfferings={data.products} loading={loading} />
    <Loader hide={!loadingMore} pb0 />
  </FullWidthContainer>
)

type Outter = {|
  geolocations: ?Location[],
  productGroups: ?ProductGroup[],
|}

const enhancer: HOC<*, Outter> = (compose(
  withQuery(
    listProductOfferingsQuery,
    {
      variables: ({activity, geolocations, productGroups, ...rest}) => (
        {
          productGroups: productGroups 
            ? productGroups.map(productGroup => productGroup.name)
            : undefined,
          locationIds: geolocations 
            ? geolocations.map(geo => geo.id)
            : undefined,
          ...rest,
        }
      ),
    },
  ),
  withScrollEnd(props => props.loadMore()),
))

export default enhancer(NearbyProducts)



// WEBPACK FOOTER //
// ./src/pages/Products/NearbyProducts.js